export default __webpack_public_path__ + "static/albums_background-985309303728c55c6b722c6876532dd2.png";